<template>
  <div class="login-page">
    <div class="logo"><img src="../assets/login/logo.png" alt="logo" /></div>
    <div class="login-card">
      <div class="login-left">
        <el-form :model="loginForm" :rules="rules" ref="loginForm" label-width="90px">
          <el-form-item v-if="isShowPerinfoList" label="考核期次" prop="ExamPeriodInfoId">
            <el-select
              v-model="loginForm.ExamPeriodInfoId"
              class="form-input-full"
              placeholder="请选择考核期次"
              @change="setCurrentItem"
            >
              <el-option
                v-for="item in examPeriodInfoList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="身份证号" prop="IDCard">
            <el-input
              v-model="loginForm.IDCard"
              class="idcard-input"
              placeholder="请输入身份证号"
              @keyup.enter.native="submitForm()"
              maxlength="18"
            ></el-input>
          </el-form-item>
          <div class="keypad">
            <div class="codeNum" @click="inputText('1')">1</div>
            <div class="codeNum" @click="inputText('2')">2</div>
            <div class="codeNum" @click="inputText('3')">3</div>
            <div class="codeNum" @click="inputText('0')">0</div>
            <div class="codeNum" @click="inputText('4')">4</div>
            <div class="codeNum" @click="inputText('5')">5</div>
            <div class="codeNum" @click="inputText('6')">6</div>
            <div class="codeNum codeNum-x" @click="inputText('X')">X</div>
            <div class="codeNum" @click="inputText('7')">7</div>
            <div class="codeNum" @click="inputText('8')">8</div>
            <div class="codeNum" @click="inputText('9')">9</div>
            <div class="codeNum codeNum-del" @click="inputTextDel()">删除</div>
          </div>
          <el-form-item class="btn-group">
            <el-button class="btnClean" @click="resetForm()">清除</el-button>
            <el-button
              class="btnSubmit"
              :disabled="btnIsDisable"
              type="success"
              @click="submitForm()"
              >{{ currentIsExam ? "确认" : "模拟" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="login-right">
        <p class="tipTitle">考生须知</p>
        <ul class="tip-list">
          <li>考生入场考试，需在考生签字表上签到，未签到的按缺考处理。</li>
          <li>进入考场后，请将手机调到静音状态或关机，将身份证和准考证摆放在桌面左侧，以便监考人员查检。</li>
          <li>登录考试系统后，请先核实对考生信息，如姓名、身份证号等，如有出入，请在考试结束后与监考人员联系更正。</li>
          <li>考试过程中，如出现断电、网络中断或计算机故障等意外情况，请及时举手示意监考人员，切勿擅自处理。</li>
          <li>考试过程中，不得交头接耳，不得大声喧哗，不得夹带与考试有关的资料、不得接打电话，不得使用电子存储设备。</li>
          <li>请在左侧的登录页面输入身份证号，登录考试；登录后，系统按规定的考试时间计时。</li>
          <li>考生在规定的时间内未完成答题的，系统自动提交，结束考试。</li>
          <li>提交试卷、结束考试后，考生退离考场，不得在考场滞留。</li>
        </ul>
      </div>
    </div>
    <div class="foot">技术支持：山西传人科技有限公司</div>
  </div>
</template>

<script>
import {
  getExamPeriodInfoList,
  getQuestionList,
  getIDCardRelevanceExamPeriodInfoList,
} from "../api/index.js";
export default {
  name: "Index",
  data() {
    return {
      systemName: "山西传人科技企业培训综合管理平台",
      examPeriodInfoList: [],
      btnIsDisable: false,
      currentIsExam: true,
      loginForm: {
        IDCard: "",
        ExamPeriodInfoId: "",
        IsTest: false,
      },
      rules: {
        IDCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            min: 18,
            max: 18,
            message: "请输入正确的身份证号",
            trigger: "blur",
          },
        ],
        ExamPeriodInfoId: [
          { required: true, message: "请选择考核期", trigger: "change" },
        ],
      },
      changeBgTimer: null,
      pageRouteKey: "",
      isShowPerinfoList: false,
    };
  },
  methods: {
    submitForm() {
      let _this = this;
      this.$refs["loginForm"].validate((valid) => {
        if (valid) {
          if (_this.isShowPerinfoList == true) {
            //查询考核题目信息
            _this.getExamQuestion();
          } else {
            //查询校验身份证号是否存在多个考核批次
            let queryParam = {
              routeKey: _this.pageRouteKey,
              idcard: _this.loginForm.IDCard,
            };
            _this.btnIsDisable = true;
            getIDCardRelevanceExamPeriodInfoList(queryParam)
              .then((res) => {
                _this.btnIsDisable = false;
                if (res.state == "success") {
                  //如果只有一个考核期次，直接查询获取题目信息
                  _this.examPeriodInfoList = res.data;
                  if (_this.examPeriodInfoList.length == 0) {
                    _this.$message.warning("未查询到您的考核期次信息");
                    return false;
                  } else if (_this.examPeriodInfoList.length > 1) {
                    _this.isShowPerinfoList = true;
                    return false;
                  }
                  //查询考核题目信息
                  _this.currentIsExam = !res.data[0].TestAble;
                  _this.loginForm.ExamPeriodInfoId = res.data[0].Id;
                  _this.getExamQuestion();
                } else {
                  _this.$message.error(res.message);
                }
              })
              .catch((error) => {
                _this.btnIsDisable = false;
                _this.$message.error("网络连接失败，请稍后重试");
              });
          }
        } else {
          return false;
        }
      });
    },
    //查询获取考核题目信息
    getExamQuestion() {
      let _this = this;
      let isTest = !this.currentIsExam;
      _this.loginForm.IsTest = isTest;
      _this.btnIsDisable = true;
      getQuestionList(_this.loginForm)
        .then((res) => {
          _this.btnIsDisable = false;
          if (res.state == "success") {
            _this.resetForm();
            sessionStorage.setItem("examData", JSON.stringify(res.data));
            if (isTest) {
              _this.$router.push("/test");
            } else {
              _this.$router.push("/exam");
            }
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.btnIsDisable = false;
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //重置表单
    resetForm() {
      this.$refs["loginForm"].resetFields();
    },
    //联动判断是否展示模拟按钮
    setCurrentItem(itemData) {
      let _this = this;
      this.examPeriodInfoList.forEach((item) => {
        if (itemData == item.Id) {
          _this.currentIsExam = !item.TestAble;
        }
      });
    },
    //绑定考核期次信息
    bindExamPeriodInfo() {
      var _this = this;
      let queryParam = {
        routeKey: this.pageRouteKey,
      };
      getExamPeriodInfoList(queryParam)
        .then((res) => {
          if (res.state == "success") {
            _this.examPeriodInfoList = JSON.parse(res.data);
            if (_this.examPeriodInfoList.length == 0) {
              _this.btnIsDisable = true;
              _this.$message.warning("暂无考核期次");
            }
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    inputText(num) {
      if (this.loginForm.IDCard) {
        if (this.loginForm.IDCard.length < 18) {
          this.loginForm.IDCard += num;
        }
      } else {
        this.loginForm.IDCard = num;
      }
    },
    inputTextDel() {
      if (this.loginForm.IDCard && this.loginForm.IDCard.length > 1) {
        this.loginForm.IDCard = this.loginForm.IDCard.slice(
          0,
          this.loginForm.IDCard.length - 1
        );
      } else {
        this.loginForm.IDCard = "";
      }
    },
  },
  activated() {
    sessionStorage.setItem("indexPage", "login");
    this.isShowPerinfoList = false;
    let routeKey = "";
    let currentDomain = window.location.hostname;
    //根据域名判断rk值
    if (currentDomain.indexOf("sypxzx") > -1) {
      routeKey = "syyp";
      //写入缓存中
      sessionStorage.setItem("routeKey", routeKey);
    } else {
      //查询url中的单位编号信息
      routeKey = this.$route.query.rk;
      if (routeKey) {
        //写入缓存中
        sessionStorage.setItem("routeKey", routeKey);
      } else {
        //查询缓存中
        routeKey = sessionStorage.getItem("routeKey");
      }
    }
    if (routeKey) {
      //判断路由参数赋值系统名称
      switch (routeKey) {
        case "lf":
          document.title = "临汾市在线考核管理系统";
          this.systemName = "临汾市在线考核管理系统";
          break;
        case "jzzy":
          document.title = "晋中职院在线考核管理系统";
          this.systemName = "晋中职院在线考核管理系统";
          break;
        case "hmgh":
          document.title = "干河煤矿在线考核管理系统";
          this.systemName = "干河煤矿在线考核管理系统";
          break;
        case "ywmy":
          document.title = "余吾煤业在线考核管理系统";
          this.systemName = "余吾煤业在线考核管理系统";
          break;
        case "syyp":
          document.title = "寿阳县应急管理事务服务中心在线考核管理系统";
          this.systemName = "寿阳县应急管理事务服务中心在线考核管理系统";
          break;
        default:
          break;
      }
      this.pageRouteKey = routeKey;
      sessionStorage.setItem("systemName", this.systemName);
      //this.bindExamPeriodInfo();
    } else {
      this.$message.error("页面地址参数有误，请联系管理员");
    }
    if (!this.changeBgTimer) {
      this.changeBgTimer = setInterval(this.autoChangeBg, 60000);
    }
  },
};
</script>

<style scoped>
.login-page {
  min-height: 100%;
  background: #0a1628 url("../assets/login/bbg.jpg") no-repeat center top;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  text-align: center;
  padding: 60px 0 40px;
}

.logo img {
  max-height: 80px;
  width: auto;
}

.login-card {
  display: flex;
  width: 920px;
  max-width: 95vw;
  min-height: 480px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  margin-bottom: 40px;
}

.login-left {
  flex: 0 0 400px;
  padding: 40px 36px 32px;
  border-right: 1px solid #e8eaec;
}

.login-right {
  flex: 1;
  padding: 40px 36px;
  color: #1e4d8c;
  overflow-y: auto;
}

.form-input-full {
  width: 100%;
}

.idcard-input >>> .el-input__inner {
  font-size: 20px;
  letter-spacing: 2px;
  height: 48px;
  line-height: 48px;
}

.keypad {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin: 16px 0 20px;
}

.codeNum {
  height: 52px;
  line-height: 52px;
  border-radius: 8px;
  text-align: center;
  background: linear-gradient(180deg, #3a6cb5 0%, #1e4d8c 100%);
  font-size: 22px;
  color: #fff;
  cursor: pointer;
  user-select: none;
  transition: all 0.15s ease;
  box-shadow: 0 2px 6px rgba(30, 77, 140, 0.3);
}

.codeNum:hover {
  background: linear-gradient(180deg, #4a7cc5 0%, #2f6cb5 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(30, 77, 140, 0.4);
}

.codeNum:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(30, 77, 140, 0.3);
}

.codeNum-x {
  background: linear-gradient(180deg, #5a7ab5 0%, #3a5a8c 100%);
}

.codeNum-del {
  background: linear-gradient(180deg, #e85d5d 0%, #c0392b 100%);
  font-size: 16px;
  box-shadow: 0 2px 6px rgba(192, 57, 43, 0.3);
}

.codeNum-del:hover {
  background: linear-gradient(180deg, #f06d6d 0%, #d0493b 100%);
}

.btn-group {
  margin-bottom: 0;
}

.btn-group >>> .el-form-item__content {
  display: flex;
  gap: 12px;
  margin-left: 0 !important;
}

.btnClean,
.btnSubmit {
  flex: 1;
  height: 52px;
  border: none;
  border-radius: 8px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}

.btnClean {
  background: linear-gradient(180deg, #6b8fc7 0%, #4a6fa5 100%);
}

.btnClean:hover {
  background: linear-gradient(180deg, #7b9fd7 0%, #5a7fb5 100%);
  color: #fff;
}

.btnSubmit {
  background: linear-gradient(180deg, #52c41a 0%, #389e0d 100%);
}

.tipTitle {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1e4d8c;
  padding-bottom: 12px;
  border-bottom: 2px solid #e8f0fe;
}

.tip-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tip-list li {
  position: relative;
  padding-left: 20px;
  margin-bottom: 14px;
  font-size: 14px;
  line-height: 1.7;
  color: #374151;
}

.tip-list li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 9px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1e4d8c;
}

.foot {
  margin-top: auto;
  width: 100%;
  background: rgba(255, 255, 255, 0.95);
  text-align: center;
  color: #1e4d8c;
  line-height: 1;
  font-size: 14px;
  padding: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue